import { CircularProgress } from "@mui/material";
import { Stack } from "@mui-wrapper";

/** Shows a spinner in the middle of the page trying to force itself to be "as big as possible" and centered */
export function Spinner(): React.JSX.Element {
  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "80px",
        alignItems: "center",
        justifyContent: "space-around",
      }}
    >
      <CircularProgress />
    </Stack>
  );
}
